import { combineReducers } from "redux";
import auth from "./auth";
import user from "./user";
import modal from "./modal";
import enrollment from "./enrollment";
import course from "./course";
import statics from "./statics";
import file from "./file";
import quiz from "./quiz";

const createRootReducer = combineReducers({
  authStore: auth,
  modalStore: modal,
  userStore: user,
  enrollmentStore: enrollment,
  courseStore: course,
  staticsStore: statics,
  fileStore: file,
  quizStore: quiz,
});

export default createRootReducer;
